import { CustomIconProps } from './index';

export const PasteIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <path fill={color || 'black'} d="M11 5h5V4h-5z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 7V5H9v3H6v11h9v-4h3V7zm-5 10v-7H8v7h5zm3-4h-1V8h-4V7h5v6zm-7 0h3v-2H9v2zm3 3H9v-2h3v2z"
                fill={color || 'black'}
            />
        </svg>
    );
};
